import { FormBuilder, FormControl } from '@angular/forms';

import { AllocationViewFiltersModel } from '../../allocation-view/models';

export class AllocationViewFilterProfileModel {
  id: number;
  name: string;
  filters: AllocationViewFiltersModel;

  constructor(params?: AllocationViewFilterProfileModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class AllocationViewFilterProfileFormModel {
  constructor(
    model: AllocationViewFilterProfileModel,
    fb: FormBuilder = new FormBuilder(),
    public id: FormControl<number> = fb.control<number>(model.id),
    public name: FormControl<string> = fb.control<string>(model.name),
    public filters: FormControl<AllocationViewFiltersModel> = fb.control<AllocationViewFiltersModel>(model.filters, []),
  ) {}
}
